<template>
  <div>
    <div class="row justify-content-center mt-4 mb-5">
      <div class="col-md-10">
        <h3 class="mb-3">{{purchase.ref_number}}</h3>
        <form
          class="form-horizontal "
          role="form"
        >
          <div class="form-inline mb-3">
            <div class="col-md-3">Price</div>
            <div class="col-md-9">
              <v-field :v="$v.purchase.price_unit">
                <input
                  type="text"
                  id="unit_price"
                  placeholder="Price"
                  class="form-control"
                  autofocus
                  v-model="purchase.price_unit"
                  @keyup="calculatePrice"
                  @blur="$v.purchase.price_unit.$touch()"
                />
              </v-field>
            </div>
          </div>
          <div class="form-inline mb-3">
            <div class="col-md-3">Quantity</div>
            <div class="col-md-9">
              <v-field :v="$v.purchase.qty">
                <input
                  type="text"
                  id="qty"
                  placeholder="Quantity"
                  class="form-control"
                  autofocus
                  v-model="purchase.qty"
                  @keyup="calculatePrice"
                  @blur="$v.purchase.qty.$touch()"
                />
              </v-field>
            </div>
          </div>
          <div class="form-inline mb-3">
            <div class="col-md-3">Discount</div>
            <div class="col-md-9">
              <v-field :v="$v.purchase.discount">
                <input
                  type="text"
                  id="discount"
                  placeholder="discount"
                  class="form-control"
                  v-model="purchase.discount"
                  @keyup="calculatePrice"
                  @blur="$v.purchase.discount.$touch()"
                />
              </v-field>
            </div>
          </div>
          <div class="form-inline mb-3">
            <div class="col-md-3">Tax</div>
            <div class="col-md-9">
              <v-field :v="$v.purchase.tax">
                <input
                  type="text"
                  id="tax"
                  placeholder="Tax"
                  class="form-control"
                  v-model="purchase.tax"
                  @keyup="calculatePrice"
                  @blur="$v.purchase.tax.$touch()"
                />
              </v-field>
            </div>
          </div>

          <div class="form-inline mb-3">
            <div class="col-md-3">Price Total</div>
            <div class="col-md-9">
              <v-field :v="$v.purchase.price_total">
                <input
                  type="text"
                  id="price_total"
                  placeholder="Price Total"
                  class="form-control"
                  disabled
                  v-model="purchase.price_total"
                  @blur="$v.purchase.price_total.$touch()"
                />
              </v-field>
            </div>
          </div>
          <div class="col-md-12">
            <label
              for="payment_type"
              class="mr-4 control-label"
            >Paid By</label>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                name="payment_type"
                id="payment_type_cash"
                value="CASH"
                v-model="purchase.payment_type"
                :v="$v.purchase.payment_type"
              />
              <label
                class="form-check-label"
                for="payment_type_cash"
              >Cash</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                name="payment_type"
                id="payment_type_bank"
                value="BANK"
                v-model="purchase.payment_type"
                :v="$v.purchase.payment_type"
              />
              <label
                class="form-check-label"
                for="payment_type_bank"
              >Bank</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                name="payment_type"
                id="payment_type_card"
                value="CARD"
                v-model="purchase.payment_type"
                :v="$v.purchase.payment_type"
              />
              <label
                class="form-check-label"
                for="payment_type_card"
              >Card</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                name="payment_type"
                id="payment_type_free"
                value="FREE"
                :checked=true
                v-model="purchase.payment_type"
                :v="$v.purchase.payment_type"
              />
              <label
                class="form-check-label"
                for="payment_type_free"
              >FREE</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                name="payment_type"
                id="payment_type_sub"
                value="SUB"
                v-model="purchase.payment_type"
                :v="$v.purchase.payment_type"
              />
              <label
                class="form-check-label"
                for="payment_type_sub"
              >Subscription</label>
            </div>
          </div>
          <div>
            <button
              type="submit"
              class="btn btn-primary btn-block"
              @click.prevent="updatePurchase"
              :class="{ invalid: $v.$invalid }"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  between,
  maxLength
} from "vuelidate/lib/validators";
export default {
  props: ["purchase"],
  mixins: [validationMixin],
  data() {
    return {
      isInit: false,
      loading: false
      /* purchase: {
        price_unit: 0,
        discount: 0,
        tax: 0,
        price_total: 0,
        payment_type: null
      } */
    };
  },
  computed: {
    /* price_unit() {
      this.purchase.price_unit;
    },
    discount() {
      this.purchase.discount;
    },
    tax() {
      this.purchase.tax;
    },
    price_total() {
      this.purchase.price_total;
    },
    payment_type() {
      this.purchase.payment_type;
    } */
  },
  mounted() {
    //this.isInit = true;
    //console.log(this.purchase);
    /* this.price_unit = this.purchase.price_unit;
    this.discount = this.purchase.discount;
    this.tax = this.purchase.tax;
    this.price_total = this.purchase.price_total;
    this.payment_type = this.purchase.payment_type;
    this.isInit = true; */
    //console.log(this.price_unit);
  },
  validations: {
    purchase: {
      price_unit: {
        required
      },
      tax: {
        required
      },
      qty: {
        required
      },
      discount: {
        required
      },
      price_total: {
        required
      },
      payment_type: {
        required
      }
    }
  },
  methods: {
    calculatePrice() {
      this.purchase.price_total =
        parseFloat(this.purchase.price_unit) * parseFloat(this.purchase.qty) -
        parseFloat(this.purchase.discount) +
        parseFloat(this.purchase.tax);
    },
    async updatePurchase() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        //alert("All fields are not valid");
      } else {
        this.loading = true;

        await axios
          .post("/api/purchases/updateinfo", {
            purchase: this.purchase
          })
          .then(response => {
            this.$emit("close");
          })
          .catch(function(error) {
            let errormsg = error.response.data.error;
            if (error.response.status == 500) {
              self.isUpdateError = true;
            }
          })
          .finally(() => (this.loading = false));
      }
    }
  }
};
</script>